import getCurrentGroup from './getCurrentGroup';

export default function getReportingPlatformDisplayName(
  state: any
): string | undefined {
  const currentGroup = getCurrentGroup(state);
  return currentGroup.get('reportingPlatformDisplayName');
}
